import classNames from 'classnames';
import React from 'react';

const GifViewer = ({ classNames, src, alt = 'GIF image', width = '300px', height = 'auto' }) => {
  return (
      <img src={src} alt={alt} style={{ height }} className={classNames} />
  );
};

export default GifViewer;
